var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 828,
    height: 167.131,
    viewBox: "0 0 828 167.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7294",
    "data-name": "Group 7294",
    transform: "translate(-274.093 -1373.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6770",
    "data-name": "Path 6770",
    d: "M601.913,433.889a40.049,40.049,0,0,0,.132,80.1c21.5-.014,39.746-18.384,39.654-39.9-.095-21.942-18.182-40.229-39.786-40.2Zm-4.459,123.454c-27.573-.944-52.937-13.887-69.649-41.871-8.14-13.629-11.362-28.671-10.78-44.6.8-21.742,8.709-40.37,23.972-55.655,13.179-13.2,29.188-20.883,47.62-23.582,16.753-2.443,32.995-.672,48.448,6.254,25.159,11.272,41.425,30.386,47.594,57.514,7.19,31.657-3.923,64.94-30.859,84.969C638.352,551.856,620.936,557.243,597.455,557.343Z",
    transform: "translate(57.856 982.784)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6772",
    "data-name": "Path 6772",
    d: "M1199.9,578.4l-43.269-62.131-7.643,10.978,40.621,58.318A6.27,6.27,0,0,0,1199.9,578.4Z",
    transform: "translate(-99.061 951.649)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6773",
    "data-name": "Path 6773",
    d: "M1123.153,563.946l-7.646,10.977,15.7,22.536a6.274,6.274,0,0,0,10.293-7.178Z",
    transform: "translate(-90.727 939.784)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6774",
    "data-name": "Path 6774",
    d: "M982.017,557.217a6.372,6.372,0,0,1-5.322-9.859l51.84-69.637a6.232,6.232,0,0,0-.007-7.458l-51.919-69.471a6.387,6.387,0,0,1,5.333-9.9h62.115a7.265,7.265,0,0,1,6.007,3.159c7.833,11.369,43.887,62.868,53.485,76.581a5.71,5.71,0,0,1-.049,6.643c-11.709,16.242-44.971,64.368-54.528,78.384a3.627,3.627,0,0,1-3,1.57Z",
    transform: "translate(-55.892 982.71)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6775",
    "data-name": "Path 6775",
    d: "M1200.07,400.495,1156.8,462.61l-7.643-10.96,40.619-58.319a6.271,6.271,0,0,1,10.295,7.164Z",
    transform: "translate(-99.102 982.772)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6776",
    "data-name": "Path 6776",
    d: "M1170.987,400.381l-30.832,44.274-7.646-10.974,28.186-40.463a6.27,6.27,0,0,1,10.292,7.164Z",
    transform: "translate(-94.959 982.8)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6777",
    "data-name": "Path 6777",
    d: "M1123.315,426.806l-7.644-10.975,15.7-22.537a6.274,6.274,0,0,1,10.292,7.179Z",
    transform: "translate(-90.767 982.78)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6778",
    "data-name": "Path 6778",
    d: "M1170.823,584.43l-30.832-44.274-7.646,10.977,28.187,40.461a6.269,6.269,0,0,0,10.291-7.164Z",
    transform: "translate(-94.918 945.705)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6780",
    "data-name": "Path 6780",
    d: "M815.055,430.564v39c8.7,0,17.125.014,25.563,0,9.041,0,14.731-4.011,17.864-12.568,4.151-11.343-3.119-25.54-14.062-26.3-9.7-.657-19.487-.129-29.365-.129Zm-.216,79.3v47.3H770.726V390.368c.981-.072,1.943-.187,2.9-.187,23.8,0,47.6-.243,71.387.072,21.507.27,39.451,8.486,51.587,26.855,21.633,32.714,7.118,81.311-37.5,91.183a83.9,83.9,0,0,1-16.2,1.5C833.7,510.02,824.474,509.862,814.839,509.862Z",
    transform: "translate(-5.122 982.91)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6771",
    "data-name": "Path 6771",
    d: "M309.492,390.573h43.927v64.738h47.3v-64.7h44.1V557.306H400.941v-62h-47.41v62.027H309.492Z",
    transform: "translate(109.314 982.791)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6779",
    "data-name": "Path 6779",
    d: "M243.025,500.677c-1.3-13.813-7.206-25.141-18.837-33.085-10.284-7.027-22.109-10.027-33.862-13.327a191.4,191.4,0,0,1-19.2-6.627,8.172,8.172,0,0,1-5.225-8.015c.089-4.184,1.924-7.742,5.95-9.287a28.312,28.312,0,0,1,9.378-2.1c12.815-.27,24.739,3.26,36.21,9.172l22.6,12.2V406.826c-2.771-1.674-5.2-3.317-7.764-4.672-15.134-8.015-31.427-11.314-48.354-11.842-12.723-.388-24.978,1.855-36.381,7.757-11.846,6.127-21.185,14.8-25.4,27.854-6.3,19.542.023,42.414,20.79,54.056,10.968,6.142,22.953,9.3,34.789,13.028a124.443,124.443,0,0,1,17.632,7.085c3.91,1.93,5.466,5.571,4.279,10.2a10.32,10.32,0,0,1-8.858,7.986,66.729,66.729,0,0,1-16.362.741c-11.934-1.056-23.279-4.3-33.631-11.254v-.013l-23.752-16.242v48.438c2.771,1.631,5.217,3.23,7.8,4.557a115.147,115.147,0,0,0,43.378,12.144c14.555,1.241,28.943.956,42.9-4.086,11.25-4.057,20.546-10.556,26.568-21.212C243.09,521.777,244.024,511.334,243.025,500.677Z",
    transform: "translate(157.067 982.866)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopx);
export default __webpack_public_path__ + "static/media/shopx.ef1d10922c52509599ccd0a24611e87f.svg";
export { ForwardRef as ReactComponent };